
import { Component, Vue } from 'vue-property-decorator'
import { IMockViolationUser, MOCK_TOP_USERS } from '@/constants/monitor-mock'

@Component({ name: 'DashboardTopUsersTable' })
export default class DashboardTopUsersTable extends Vue {
    private rows = MOCK_TOP_USERS

    /** 行点击：模块一仅路由到风控监测占位页，模块二接入用户详情 */
    private onClick(row: IMockViolationUser) {
        this.$router.push('/monitor/risk').catch(() => { /* 路由已注册 */ })
    }

    /**
     * 峰值色调：
     *   ≥ 50 → 红色加粗（异常）
     *   ≥ 30 → 琥珀加粗（关注）
     *   < 30 → 默认
     */
    private peakTone(peak: number): string {
        if (peak >= 50) return 'up'
        if (peak >= 30) return 'warn'
        return ''
    }
}
